import { Component, HostBinding, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-hover-button",
  templateUrl: "./hover-button.component.html",
  styleUrls: ["./hover-button.component.scss"],
})
export class HoverButtonComponent implements OnInit {
  @Input()
  width = "max-content";

  @Input()
  height = "30px";

  @Input()
  color = "white";

  @Input()
  border = "0";

  @Input()
  backgroundColor = "#232f3a";

  @Input()
  hoverClass: "" | "transparent" | "grey" = "";

  @Input()
  disabled = false;

  @HostBinding("class.disabled")
  get isDisabled(): boolean {
    return this.disabled;
  }

  @HostBinding("attr.aria-disabled")
  get ariaDisabled(): true | null {
    return this.disabled ? true : null;
  }

  constructor() {}

  ngOnInit() {}
}
